import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EventType } from 'src/shared/enums/event-type.enum';
import { AvatarModule } from 'primeng/avatar';
import { EventApiResponse } from 'src/shared/services/events.service';
import { Router } from '@angular/router';

@Component({
  selector: 'mohlel-event-card',
  imports: [TranslateModule, CommonModule, AvatarModule],
  templateUrl: './event-card.component.html',
  styleUrl: './event-card.component.scss',
})
export class EventCardComponent {
  eventData = input.required<EventApiResponse>();
  EventType = EventType;
  eventType: EventType = EventType.Dividend;
  translate = inject(TranslateService);
  router = inject(Router);
  ngOnInit() {
    this.eventType = this.eventData().type as EventType;
  }

  getEventTypeColor(type: EventType | string): string {
    switch (type) {
      case EventType.Dividend:
        return '#179F5E';
      case EventType.Earning:
        return '#D3AC5F';
      case EventType.Ipo:
        return '#5098ED';
      default:
        return '#ffffff8f';
    }
  }

  getEventTypeLabel(type: EventType | string): string {
    switch (type) {
      case EventType.Dividend:
        return this.translate.instant('events.dividends');
      case EventType.Earning:
        return this.translate.instant('events.earning');
      case EventType.Ipo:
        return this.translate.instant('events.ipo');
      default:
        return '';
    }
  }

  navigateToStock(eventType: EventType) {
    if (eventType === EventType.Ipo) return;

    this.router.navigate(['/sectors/company', this.eventData().stockId], {
      queryParams: {
        tab: eventType === EventType.Dividend ? 'dividends' : 'profile',
      },
    });
  }
}
